import styled, { css } from 'styled-components';

import { DEVICE_SIZES } from '../../constants/common';

export const Wrapper = styled.div`
  border-radius: 24px;
  padding: 30px 32px;
  margin: 0 auto 40px auto;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;

  ${({ theme }) => css`
    background-color: ${theme.colorBgLayout};
    border: 1px solid ${theme.colorBgLayout};
  `}

  @media (max-width: ${DEVICE_SIZES.tablet}) {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
    padding: 24px;
  }
`;

export const Left = styled.div`
  flex: 1 1 0;
`;

export const Right = styled.div`
  min-width: 190px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;

  @media (max-width: 900px) {
    min-width: 0;
  }
`;

export const PriceTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 18px 0;

  @media (max-width: ${DEVICE_SIZES.tablet}) {
    font-size: 24px;
  }
`;

export const PriceText = styled.div`
  font-size: 18px;
  margin-bottom: 16px;

  @media (max-width: ${DEVICE_SIZES.tablet}) {
    font-size: 14px;
  }
`;

export const PriceEmail = styled.a`
  font-size: 18px;
  margin-bottom: 4px;
  text-decoration: underline;
  color: ${({ theme }) => theme.colorInfo};

  &:hover {
    text-decoration: underline;
  }
`;

export const PricePhone = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.brandDefault};
  display: flex;
  align-items: center;
  gap: 4px;
`;
